// 🚨 AUTO-GENERADO desde ProviderInvoicePaymentDataType.ts - No editar manualmente

export const ProviderInvoicePaymentFormDataKeys = [
  "id",
  "monto",
  "recibo",
  "cobrador",
  "forma_pago",
  "reference",
  "exchange_rate",
  "descripcion",
  "estado",
  "created",
  "digitosTarjeta",
  "numAprobacion",
  "creditOperatorId",
  "providerRecibeId",
  "bankAccountId",
  "bankAccount",
  "providerInvoiceId",
  "providerInvoice",
  "currencyId",
  "currency"
] as const;
